
const Professors = () => {
    const professorsList = [
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        { name: "Dr. Katozian" },
        {  name: "Dr. Katozian" },
        {  name: "Dr. Katozian" },
        {  name: "Dr. Katozian" },
    ];
    const columns = [
      professorsList.slice(0, 3),
      professorsList.slice(3, 6),
      professorsList.slice(6, 9),
      professorsList.slice(9, 12),
    ];
  
    return (
      <div className="w-full flex flex-col justify-center items-center py-[20px] mt-4 lg:mt-6 border-t border-stroke1 relative">
        <h2 className="my-10 max-md:mb-5 text-[22px] max-md:text-[18px] md:text-[32px] text-subColor5 font-semibold">
          Some top professors and resources      
        </h2>
        <h6 className="text-text3 text-[14px] max-md:text-[10px] leading-6 max-md:leading-[14px] max-w-[560px] max-md:max-w-[300px] text-center">
          Deploy an AI app in seconds on Vercel, <span className="text-text2">using our pre-built templates.</span> Deploy an AI app in seconds on Vercel, <span className="text-text2">using our pre-built templates.</span>
        </h6>
  
        <div className="flex justify-between gap-4 mt-10 w-full">
          {columns.map((col, index) => (
            <div key={index} className="flex flex-col gap-4">
              {col.map((professor , colIndex) => (
                <div
                  key={colIndex}
                  className="h-[170px] bg-gradient-to-b from-[#222327] via-[#313035] to-[#232428] p-4 flex flex-col justify-between"
                >
                  <h4 className="text-white">{professor.name}</h4>
                  <p className="text-text2 text-[12px]">
                    Deploy an AI app in seconds on Vercel, using our pre-built templates.
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="w-full h-[300px] absolute bottom-0 left-0 bg-gradient-to-b to-[#09090B] from-transparent"></div>
      </div>
    );
  };
  
  export default Professors;
  